import { getStylesObjFromCss } from '../../../../utils/common/styling.js';

var styles = getStylesObjFromCss({
    styles: {},
    componentName: "MobileModal",
});

export { styles };
//# sourceMappingURL=MobileModal.styles.js.map
